import * as z from "zod";
import { zql } from "../generatedDrizzleSchema";
import { collectDestinationCidrs } from "./egressRouteShared";
import { mutator } from "./mutator";

const deleteEgressRouteSchema = z.object({ id: z.string() });

export const deleteEgressRoute = mutator({
  schema: deleteEgressRouteSchema,
  resolve: { egressRoute: { kind: "egressRoute", from: "id" } },
  permissions: [
    {
      permission: "tenant:egress_routes_manage",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
    {
      permission: "network:use",
      scopeId: ({ args }) => args.egressRoute.network.id,
    },
  ],
  fn: async ({ tx, args: { egressRoute } }) => {
    const { network } = egressRoute;
    await tx.mutate.egressRoutes.delete({ id: egressRoute.id });

    const remaining = (
      await tx.run(zql.egressRoutes.where("networkId", network.id))
    ).filter((r) => r.id !== egressRoute.id);
    await tx.mutate.networks.update({
      id: network.id,
      configuration: {
        ...network.configuration,
        destinationCidrs: collectDestinationCidrs(remaining),
      },
    });
  },
});
